import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../common/FormUtils';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../common/FormModal';
import AnnoucementService from './AnnoucementService';
import DirectoryService from '../directory/DirectoryService';
import schema from './jsonSchema';
import GroupService from '../groups/GroupService';
const jsonSchema = schema;

const mergedJsonSchema = (jsonSchema, users) => {
  return jsonSchema.map(field => {
    if (field.name === 'audience') {
      return {
        ...field,
        options: users
      };
    }

    return field;
  });
};
const AnnoucementForm = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [users, setUsers] = useState();
  useEffect(() => {
    const fetchData = async () => {
      if (identifier) {
        AnnoucementService.retrieveAnnoucement(identifier)
          .then(data => {
            const audienceValues = data.audience.map(p => ({
              label: p.firstName + ' ' + p.lastName,
              value: p.identifier,
              type: 'profile'
            }));
            const groupsValues = data.groups.map(g => ({
              label: g.name,
              value: g.identifier,
              type: 'group'
            }));
            data.audience = groupsValues.concat(audienceValues);
            setData(data);
          })
          .catch(error => console.log(error));
      }
      const usersByAccount = await DirectoryService.retrieveUsersByAccount();
      const mappedUsers = usersByAccount.map(u => ({
        value: u.identifier,
        label: u.firstName + ' ' + u.lastName,
        type: 'profile'
      }));
      const groupsByAccount = await GroupService.retrieveAllGroupsByAccount();
      const mappedGroups = groupsByAccount.map(g => ({
        value: g.identifier,
        label: g.name,
        type: 'group'
      }));
      const mappedAudience = mappedUsers.concat(mappedGroups);
      console.log(mappedAudience);
      setUsers(mappedAudience);
    };
    fetchData();
  }, []);
  const handleAnnoucementFormSubmit = formData => {
    AnnoucementService.saveAnnoucement(formData)
      .then(response => {
        console.log(response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save Annoucement',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Annoucement');
      }
    },
    {
      name: 'Save Draft',
      type: 'submit',
      variant: 'success',
      onClick: () => {
        console.log('Save Draft');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator('Create Annoucement', ' ', []);

  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'Annoucement  has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
        />
      )}
      <Card>
        <Card.Body>
          {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleAnnoucementFormSubmit}
              users={users}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit, users }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit } = useFormGenerator(
    mergedJsonSchema(jsonSchema, users),
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};

FormGeneratorWithData.propTypes = {
  buttonsConf: PropTypes.any,
  data: PropTypes.any,
  onSubmit: PropTypes.any,
  users: PropTypes.any
};

export default AnnoucementForm;
